import React from 'react';
export const Story = () => {
  return <section className="text-lg md:text-xl text-gray-800 mb-12 leading-relaxed space-y-6" data-id="element-174" data-mp="2sn6hbw58uccr">
      <p data-id="element-175" data-mp="1iaucgzncru2w">For years, many people assume the problem is their mattress.</p>
      <p data-id="element-176" data-mp="1n2vm0dt4z6p8">So they buy another one.</p>
      <p data-id="element-177" data-mp="1n3x7zdboxdlq">Still wake up stiff.</p>
      <p data-id="element-178" data-mp="1s28g9jmc7g1u">
        Then they try stretching. Massage. Chiropractic visits. Different
        sleeping positions.
      </p>
      <p data-id="element-179" data-mp="uf9jz9zk4a4h">
        <strong data-id="element-180" data-mp="ufhvaxg177dk">And somehow... Nothing changes.</strong>
      </p>

      <blockquote className="border-l-4 border-blue-500 pl-6 italic text-gray-600 my-8 text-xl" data-id="element-181" data-mp="zdb1vrl8y3ed">
        Every morning starts the same. You wake up. Turn your head. And
        instantly feel it. That familiar stiffness. The discomfort. The
        frustration.
      </blockquote>

      <p data-id="element-182" data-mp="18bwhpezc34bg">You begin wondering:</p>
      <p data-id="element-183" data-mp="2fscdn98xmjke">
        <em data-id="element-184" data-mp="2fqrfl9nesihs">"Is this just part of getting older?"</em>
      </p>

      <p data-id="element-185" data-mp="2jtea5ibgshio">For many people, the answer isn't age. And it isn't their mattress.</p>
      <p className="text-2xl font-bold text-gray-900 mt-8" data-id="element-186" data-mp="2jvhbgyi2hx2p">
        It may be something they put their head on every single night. Their
        pillow.
      </p>
    </section>;
};